import React, { useEffect, useState } from "react"
import { useTranslation } from 'react-i18next'

import { httpOk, GET } from 'helpers/api'
import { findKeyFromArrayByValue } from 'helpers/helpers'
import { APP_GROUPS, SUPPORT } from 'helpers/apps'

function Index() {
	const { t } = useTranslation()

	const [versions, setVersions] = useState({})
	const [copiedIndex, setCopiedIndex] = useState(null)

	// Версия кассы подставляется в ссылку на установщик
	async function getVersions() {
		const response = await GET('/application-versions')
		if (httpOk(response)) setVersions(response.data)
	}

	function handleCopy(text, index) {
		navigator.clipboard.writeText(text)
		setCopiedIndex(index)
		setTimeout(() => setCopiedIndex(null), 1000)
	}

	useEffect(() => {
		getVersions()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<div className="page-header d-flex justify-content-between">
				<h4 className="vertical-center">{t('help')}</h4>
			</div>

			<div className="row align-items-start">
				<div className="col-md-6">
					{/* Связь с поддержкой */}
					<div className="card mb-3">
						<div className="card-body">
							<h6 className="mb-3">{t('support')}</h6>

							<a className="d-flex justify-content-between align-items-center py-2 text-decoration-none"
								href={`tel:${SUPPORT.phone}`}>
								<span className="d-flex align-items-center">
									<i className="uil uil-headphones-alt me-2"></i>
									{t('phone')}
								</span>
								<span className="fw-500">{SUPPORT.phone_formatted}</span>
							</a>
							<hr className="my-1" />

							<a className="d-flex justify-content-between align-items-center py-2 text-decoration-none"
								href={SUPPORT.telegram} target="_blank" rel="noreferrer">
								<span className="d-flex align-items-center">
									<i className="uil uil-telegram-alt me-2"></i>
									Telegram
								</span>
								<span className="fw-500">{t('write')}</span>
							</a>
						</div>
					</div>

					{/* Документация */}
					<div className="card mb-3">
						<div className="card-body">
							<h6 className="mb-3">{t('documentation')}</h6>

							<a className="d-flex justify-content-between align-items-center py-2 text-decoration-none"
								href={SUPPORT.docs_url} target="_blank" rel="noreferrer">
								<span className="d-flex align-items-center">
									<i className="uil uil-book-open me-2"></i>
									{t('user_documentation')}
								</span>
								<i className="uil uil-external-link-alt"></i>
							</a>
							<hr className="my-1" />

							{/* Для разработчиков интеграторов: меню, справочники, приём заказов */}
							<a className="d-flex justify-content-between align-items-center py-2 text-decoration-none"
								href={SUPPORT.api_docs_url} target="_blank" rel="noreferrer">
								<span className="d-flex align-items-center">
									<i className="uil uil-brackets-curly me-2"></i>
									{t('api_documentation')}
								</span>
								<i className="uil uil-external-link-alt"></i>
							</a>
						</div>
					</div>
				</div>

				{/* Приложения и утилиты — тот же список, что в модалке на странице входа */}
				<div className="col-md-6">
					<div className="card mb-3">
						<div className="card-body">
							<h6 className="mb-3">{t('applications')}</h6>

							{/* Список длинный (15 позиций) — держим блок компактным и скроллим внутри,
							иначе карточка растягивается на два экрана */}
							<div className="overflow-auto pe-1" style={{ 'maxHeight': '340px' }}>
								{APP_GROUPS.map((group, groupIndex) => (
									<div className="auth-apps-group" key={groupIndex}>
										<div className="auth-apps-title">{t(group.title)}</div>

										{group.items.map((item, itemIndex) => {
											const version = item.type
												? findKeyFromArrayByValue(versions, 'type', item.type, 'version')
												: ''
											const itemKey = `${groupIndex}-${itemIndex}`

											return (
												<div className="auth-apps-row" key={itemKey}>
													<div className="auth-apps-name">
														{item.name}
														{version && <span className="auth-apps-version">{version}</span>}
													</div>

													{item.action === 'copy' ?
														<div className="position-relative">
															<button type="button"
																className="btn btn-sm btn-outline-primary auth-apps-action"
																onClick={() => handleCopy(item.url(version), itemKey)}>
																<i className="uil uil-link"></i> {t('copy')}
															</button>
															{copiedIndex === itemKey &&
																<div className="auth-copied">{t('copied')}</div>
															}
														</div>
														:
														<a className="btn btn-sm btn-outline-primary auth-apps-action"
															href={item.url(version)}>
															<i className="uil uil-download-alt"></i> {t('download')}
														</a>
													}
												</div>
											)
										})}
									</div>
								))}
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	)
}

export default Index
